import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="new-setting"
export default class extends Controller {
  static targets = ["key", "value", "description", "dataType"]

  connect() {
    this.keyTarget.addEventListener("input", this.validateKey.bind(this))
  }

  validateKey() {
    const key = this.keyTarget.value
    const sanitized = key.toLowerCase().replace(/[^a-z0-9_]/g, "")
    
    if (key !== sanitized) {
      this.keyTarget.value = sanitized
    }
  }

  clear() {
    this.keyTarget.value = ""
    this.valueTarget.value = ""
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.value = ""
    }
    if (this.hasDataTypeTarget) {
      this.dataTypeTarget.value = "string"
    }
  }
}
